/**
 * Uninest/Karmabooking
 *
 * Copyright (c) 2020 Karmabunny
 */

// Cache boys.
const FORMATTERS: Record<string, Intl.NumberFormat> = {
    'en-US|JPY': new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'JPY',
        minimumFractionDigits: 0,
    })
}

export function getFormatter(locale: string, currency: string): Intl.NumberFormat {
    let key = `${locale}|${currency}`;
    let formatter = FORMATTERS[key];

    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
        });
        FORMATTERS[key] = formatter;
    }

    return formatter;
}

export function format(value?: number, currency = "JPY") {
    if (typeof value !== 'number') value = 0;
    return getFormatter(window.__translations.lang, currency).format(value);
}